import { Typography } from '@mui/material';
import React from 'react';

import LinkList, { ListItemOrientation, ListItemType } from './LinkList';
import { getArticleLink } from '../../utils/link.utils';

interface ArticleLinkListProps {
    title: string;
    articles?: { _id: string; title: string }[];
}

export const ArticleLinkList: React.FC<ArticleLinkListProps> = (props) => {
    if (!props.articles?.length) return null;

    const linksList = props.articles.map(({ _id, title }) => ({
        id: _id,
        name: title,
        url: getArticleLink(_id),
    }));

    return (
        <div>
            <Typography sx={{ mb: 2 }} variant="h5">
                {props.title}
            </Typography>
            <div id={'article-page-recent-articles'}>
                <LinkList
                    disableSort
                    items={linksList}
                    orientation={ListItemOrientation.Vertical}
                    displayType={ListItemType.Link}
                    isSpacedVerticalLinks={true}
                />
            </div>
        </div>
    );
};
